import React from "react";
import CookieBanner from "./src/components/CookieBanner";
import { initAnalytics } from "./src/utils/analytics";
import "./src/styles/global.css";

export function wrapPageElement({ element }) {
  return (
    <>
      {element}
      <CookieBanner />
    </>
  );
}

export function onClientEntry() {
  initAnalytics();
}
